import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Item, Breadcrumb, DonationInputs } from "../components";
import { LinearProgress, Grid2 as Grid } from "@mui/material";
import {
  CodeDetails,
  DefaultCodeDetails,
  Charity,
  Cause,
  CauseCollection,
  Donation,
  Settings,
  DefaultSettings,
} from "../../../shared/types";
import {
  getCauseCollection,
  getCharity,
  getSettings,
  fetchCodeDetails,
  fetchDonations,
  updateDonations,
  turnOnDirectDonation,
} from "../../../shared/utilities/actions";
import { useHash } from "../../../shared/hooks";
import * as consts from "../../../shared/utilities/consts";

export interface MainProps {
  charityId: string;
  causeId: string | null;
}

export const Main = ({ charityId, causeId }: MainProps): React.JSX.Element => {
  const [hash, setHash] = useHash();
  const [codeDetails, setCodeDetails] = useState<CodeDetails>({
    ...DefaultCodeDetails,
  });
  const [settings, setSettings] = useState<Settings>({ ...DefaultSettings });
  const [cause, setCause] = useState<Cause | null>();
  const [charity, setCharity] = useState<Charity | null>();
  const [busy, setBusy] = useState<boolean>(true);
  const [allowDonation, setAllowDonation] = useState<boolean>(true);
  const [donations, setDonations] = useState<Donation[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      await load();
    };
    fetchData();
  }, []);

  const load = async () => {
    setBusy(true);
    fetchDonations(setDonations);
    let themeId = fetchCodeDetails(codeDetails.themeId, setCodeDetails);
    let settingsResponse: Settings = await getSettings(themeId);
    setSettings(settingsResponse);
    let causeCollectionResponse: CauseCollection = await getCauseCollection(
      settingsResponse.causeCollectionId
    );
    if (
      causeCollectionResponse?.causes &&
      causeCollectionResponse.causes.length > 0
    ) {
      if (settingsResponse.restrictSelection) {
        let eins: string[] = [];
        causeCollectionResponse.causes.map((cause) => {
          eins = eins.concat(cause.eins);
        });
        if (eins.indexOf(charityId) == -1) {
          setAllowDonation(false);
        }
      }
      if (causeId) {
        let cause = causeCollectionResponse.causes.find((item) => {
          return item.id == causeId;
        });
        setCause(cause);
      }
    }
    if (charityId) {
      let charityResponse: Charity | null = await getCharity(charityId);
      setCharity(charityResponse);
    }
    setBusy(false);
  };

  return (
    <Grid size={{ xs: 12 }} container spacing={2}>
      {busy && (
        <Grid size={{ xs: 12 }}>
          <LinearProgress />
        </Grid>
      )}
      {charity && <Breadcrumb charity={charity} cause={cause} />}
      <Grid size={{ xs: 12, sm: 6 }}>
        {charity && (
          <Item
            charity={charity}
            settings={settings}
            codeDetails={codeDetails}
            donations={donations}
            handleOpenCodeInputs={() => {
              setHash("dialog-donate");
            }}
            handleOpenCreditCardInputs={async () => {
              turnOnDirectDonation();
              await load();
            }}
            handleSubmit={(donation: Donation) => {
              setBusy(true);
              let donationIndex = donations.findIndex((item) => {
                return item.ein == charity.ein;
              });
              if (donationIndex >= 0) {
                donations[donationIndex] = donation;
              } else {
                donations.push(donation);
              }
              updateDonations(donations);
              window.location.href = `/charity-checkout`;
            }}
            allowDonation={allowDonation}
          />
        )}
      </Grid>
      <Grid
        size={{ xs: 12, sm: 6 }}
        sx={{ display: { sm: "block", xs: "none" } }}
      >
        {charity && allowDonation && (
          <DonationInputs
            charity={charity}
            settings={settings}
            codeDetails={codeDetails}
            donations={donations}
            handleOpenCodeInputs={() => {
              setHash("dialog-donate");
            }}
            handleOpenCreditCardInputs={async () => {
              turnOnDirectDonation();
              await load();
            }}
            handleSubmit={(donation: Donation) => {
              setBusy(true);
              let donationIndex = donations.findIndex((item) => {
                return item.ein == charity.ein;
              });
              if (donationIndex >= 0) {
                donations[donationIndex] = donation;
              } else {
                donations.push(donation);
              }
              updateDonations(donations);
              window.location.href = `/charity-checkout`;
            }}
          />
        )}
      </Grid>
    </Grid>
  );
};
